import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { homeAnimation } from '../animation';

// 好きな外部画像URL（例：ECモール風画像）に置き換えてください
const manLaptopBg = "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&q=80";


function Home() {
  return (
    <Section id="home" bgimg={manLaptopBg}>
      <div className="overlay" />
      <motion.div className="home"
        variants={homeAnimation}
        transition={{ delay: 0.3, duration: 0.6, type: "tween" }}
      >
        <div className="content">
          <div className="title">
            <h2><p style={{ color:'var(--primary-color)' }}>低価格</p>から始められるモール運用代行</h2>
          </div>
          <div className="subTitle">
            <h1>
              初めてモール出店するけど何からしたら良いかわからない...<br />
              売上が少ないから自力で頑張っているが行き詰まっている....<br /><br />
              そんな方に<br />
              低予算でもお悩みに合わせて支援致します！
            </h1>
          </div>
        </div>
      </motion.div>
    </Section>
  );
}

const Section = styled.section`
  background: url(${props => props.bgimg}) no-repeat center;
  min-height: 80vh;
  background-size: cover;
  z-index: -5;
  border-radius: 50px 50% / 0px 0em 0px 50em;
  box-shadow: 50px 30px 50px black;
  position: relative;
  overflow: hidden;

  .overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.54); /* ★ Adjust darkness here */
    z-index: 1;
    border-radius: inherit;
    pointer-events: none;
  }

  .home {
    position: relative;
    z-index: 2;
    height: 100%;
    .content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 60%;
      color: #fff;
      gap: 1.2rem;
      margin-top: 0rem;
      padding-left: 28rem;
      .title {
        h2 {
          font-size: 50px;
          line-height: 5.3rem;
          margin-top: 15rem;
          font-weight: 900;
          letter-spacing: 0.04em;
          text-shadow: 0 3px 16px rgba(0,0,0,0.18);
        }
      }
      .subTitle {
        h1 {
          font-size: 20px;
          margin-bottom: 10rem;
          margin-top: 2rem;
          margin-left: 6rem;
          font-weight: 600;
          text-shadow: 0 2px 10px rgba(0,0,0,0.19);
        }
      }
    }
  }

  @media (max-width: 900px) {
    border-radius: 32px 32% / 0px 0em 0px 18em;
    .home .content {
      width: vw;
      padding-left: 2vw;
      margin-top: 2rem;
      .title h2 {
        font-size: 2.1rem;
        line-height: 2.7rem;
        margin-top: 8.4rem;
      }
      .subTitle h1 {
        font-size: 1.07rem;
        margin-left: 1.1rem;
        margin-bottom: 2.2rem;
        margin-top: 4.4rem;
      }
    }
  }

  @media (max-width: 600px) {
    border-radius: 14px 14% / 0px 0em 0px 5.7em;
    min-height: 33vh;
    .home .content {
      width: 97vw;
      padding-left: 0.7rem;
      .title h2 {
        font-size: 2rem;
        line-height: 2.6rem;
        margin-top: 4rem;
      }
      .subTitle h1 {
        font-size: 0.98rem;
        margin-left: 0;
        margin-bottom: 2.2rem;
        margin-top: 2rem;
      }
    }
  }
`;

export default Home;